
import Button from '../base/Button';

export default function Header() {
  return (
    <header className="w-full bg-crop-white/95 backdrop-blur-sm border-b border-crop-teal/20 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/91b17e0e4c4c5325a19775db74687ed5/c1f11ef0791542cad81f4dd0666ec5b8.png" 
              alt="CROP LABS"
              className="h-12 sm:h-16 md:h-20 w-auto object-contain"
            />
          </div>
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#servicos" className="font-gilroy text-crop-dark hover:text-crop-black transition-colors">
              Serviços
            </a>
            <a href="#segmentos" className="font-gilroy text-crop-dark hover:text-crop-black transition-colors">
              Segmentos
            </a>
            <a href="#tecnologia" className="font-gilroy text-crop-dark hover:text-crop-black transition-colors">
              Tecnologia  
            </a>
            <a href="#lumus" className="font-gilroy text-crop-dark hover:text-crop-black transition-colors">
              Lumus
            </a>
            <a href="#faq" className="font-gilroy text-crop-dark hover:text-crop-black transition-colors">
              FAQ
            </a>
          </nav>
          <div className="flex items-center space-x-3">
            <Button size="sm" variant="outline">
              <a href="https://crop-labs.com/servicos-2/" target="_blank" rel="noopener noreferrer">Outros serviços</a>
            </Button>
            <Button size="sm">
              <a href="#contato">Contato</a>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
